export const SECOND = 1000;
export const MINUTE = SECOND * 60;
export const HOUR = MINUTE * 60;
export const DAY = HOUR * 24;

export const KB = 1024;
export const MB = KB * 1024;
export const GB = MB * 1024;

// 모바일 환경에서 바텀시트에 사용되는 safe area 높이값 (픽셀)
// 드랍다운과 오버레이에 사용되는 값
// Top status bar region
export const SAFE_AREA_TOP = 64;
// Bottom CTA/footer region
export const SAFE_AREA_BOTTOM = 132;
